import { Suspense, lazy } from "react"
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import HomePage from "./pages/HomePage"
import { AuthProvider } from "./context/AuthContext"
import { ThemeProvider } from "./context/ThemeContext"
import PrivateRoute from "./routes/PrivateRoute"
import { ROUTES } from "./constants"

const LoginPage = lazy(() => import("./pages/LoginPage"))
const AdminPage = lazy(() => import("./pages/AdminPage"))

export default function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <div className="app-shell">
          <Router
            future={{
              v7_relativeSplatPath: true,
              v7_startTransition: true,
            }}
          >
            <Suspense
              fallback={
                <div className="flex min-h-screen items-center justify-center text-lg text-muted">
                  Loading...
                </div>
              }
            >
              <Routes>
                <Route path={ROUTES.HOME} element={<HomePage />} />
                <Route path={ROUTES.LOGIN} element={<LoginPage />} />
                <Route
                  path={ROUTES.ADMIN}
                  element={
                    <PrivateRoute>
                      <AdminPage />
                    </PrivateRoute>
                  }
                />
                <Route path="*" element={<Navigate to={ROUTES.HOME} />} />
              </Routes>
            </Suspense>
          </Router>
        </div>
      </ThemeProvider>
    </AuthProvider>
  )
}
